import { render } from "./quotations.vue?vue&type=template&id=9c7e7a26&scoped=true"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"

import "./quotations.vue?vue&type=style&index=0&id=9c7e7a26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c7e7a26"]])

export default __exports__